import config from "../../config";
const baseUrl = config.baseUrl;

export const ServiceDetailsUrls = {

  SERVICEDETAILS_ADD: baseUrl + "/service",
  SERVICEDETAILS_EDIT: baseUrl + "/service",
  SERVICEDETAILS_LIST: baseUrl + "/service",
  SERVICEDETAILS_DELETE: baseUrl + "/service",
  SERVICEDETAILS_GETBYID: baseUrl + "/service",
  SERVICEDETAILS_DROPDOWN: baseUrl + "/service/dropdown?export=true",
  SERVICEDETAILS_ROLLBACK: baseUrl + "/service/rollback",
  SERVICEDETAILS_DELETE_HARD: baseUrl + "/service",
};
